var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMalfunction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFC9C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2669 19.3242L12.0592 25.5319C11.3735 26.2175 11.3735 27.3293 12.0592 28.0149C12.7448 28.7007 13.8565 28.7007 14.5422 28.0149L20.7499 21.8073",
    stroke: "#FB0004",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5365 22.127L27.9413 25.5316C28.627 26.2173 28.627 27.3291 27.9413 28.0147C27.2556 28.7005 26.1438 28.7005 25.4582 28.0147L20.0078 22.5644",
    stroke: "#FB0004",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3534 15.1953L13.4912 15.816L11.6289 12.7122L12.8704 11.4707L15.9742 13.333L15.3534 15.1953ZM15.3534 15.1953L17.8381 17.6799",
    stroke: "#FB0004",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2656 19.3242C17.5248 17.4341 17.6697 14.954 19.1968 13.4269C20.7239 11.8998 23.5421 11.5647 25.0941 12.4958L22.4246 15.1652L22.1766 17.8964L24.9077 17.6483L27.5771 14.9789C28.5083 16.5308 28.1731 19.349 26.646 20.8761C25.1188 22.4033 22.6388 22.5481 20.7488 21.8072",
    stroke: "#FB0004",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalfunction);
export default __webpack_public_path__ + "static/media/Malfunction.611bd5d43e89952b934456090c7c234a.svg";
export { ForwardRef as ReactComponent };